import { useApproveRejectCustomerWill } from 'common/queries-and-mutations/admin/customer';
import Button from 'components/Form/Button';
import { Icon, Icons } from 'components/Icon';
import { InfoModal } from 'components/Modal';
import React, { useEffect, useState } from 'react';
import { selectAccountDetails } from 'selectors/account-selector';
import { useAppSelector } from 'store/hooks';

type Props = {
  onSuccess: () => void;
  onClose: () => void;
  className?: string;
  customerId: number;
  name: string;
};

export default function WillApprovalModal({
  onSuccess,
  onClose,
  className = 'w-[20%]',
  customerId,
  name
}: Readonly<Props>) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user } = useAppSelector(selectAccountDetails);
  const { mutate, isSuccess, isError } = useApproveRejectCustomerWill();

  useEffect(() => {
    if (isSuccess && !isError) {
      setIsSubmitting(false);
      onSuccess();
    }
    if (isError) {
      setIsSubmitting(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, isError]);

  const handleApprove = () => {
    setIsSubmitting(true);
    mutate({
      note: '',
      isApproved: true,
      customerId,
      staffId: +user.id!
    });
  };

  return (
    <InfoModal width={className} className="h-fit rounded-lg py-2">
      <div className="flex w-full flex-col items-center bg-white font-circular text-2xl font-bold text-[#353535]">
        <div className="w-full">
          <div className="flex items-center justify-end p-3 px-5">
            <div className="" role="button" onClick={onClose}>
              <Icon name={Icons.Close} />
            </div>
          </div>
          <div className="flex flex-col items-center justify-center p-5 text-center">
            <Icon name={Icons.CircleSuccess} />
            <p className="mt-4 text-2xl font-bold text-[#34475E]">
              Confirm will approval for {name}?
            </p>
          </div>
          <div className="mr-6 mt-5 flex items-center justify-center gap-4 pb-4">
            <Button
              type="button"
              variant="primary"
              size="md"
              className="mb-3 w-[12rem] rounded text-sm font-normal text-white"
              label="Approve Will"
              loading={isSubmitting}
              disabled={isSubmitting}
              onClick={handleApprove}
            ></Button>
          </div>
        </div>
      </div>
    </InfoModal>
  );
}
